/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { UserRevokeInvitationRequest, UserRevokeInvitationResponse } from '../types/UserRevokeInvitation'

/**
 * POST /invitations/revoke
 * @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::revokeInvitation
 */
export async function userRevokeInvitation(
	data: UserRevokeInvitationRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<UserRevokeInvitationResponse>> {
	return axiosInstance.post('/invitations/revoke', data, config)
}
